import { defineStore } from "pinia";
import { services, getHeader } from '@/assets/js/config.js'
import axios from "axios";
import { useAuthStore } from '@/stores/authStore'
import { useAccessControlStore } from './accessControlStore';

export const useNotificationStore = defineStore('notificationStore', {
	state: () => ({
		notifications: [],
		emailTemplateData: null, // Renamed state property
		setupTemplateData: null, // Renamed state property
	}),
	getters: {
		navbar_notifications(state) {
			let maxCount = 8
			let notifications = []
			for (let i = 0; i <= this.notifications.length; i++) {
				const notification = this.notifications[i]
				if (notification && i < maxCount) {
					notifications.push(notification)
				}
			}
			return notifications
		},
		emailTemplate(state) { // Getter with the same name as the state property should be removed or renamed
			return this.emailTemplateData;
		},
		setupTemplate(state) { // Getter with the same name as the state property should be removed or renamed
			return this.setupTemplateData;
		},
	},
	actions: {
		getUserNotifications() {
			return new Promise((resolve, reject) => {
				let params = {
					noti_user_id:_gAuth.activeUserId()
				}
				let queryParams = _gHlp.generateQueryParams(params)
				axios.get(services.notification + 'notifications?' + queryParams, { headers: getHeader() })
					.then(res => {
						this.notifications = _gHlp.getValue(res,'data.data',[]);
						resolve(_gHlp.getValue(res,'data',[]));
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		async markAsRead(notification) {
			if (!notification.noti_read_at) {
				try {
					const res = await axios.put(services.notification + 'notifications/' + notification.noti_id, null, { headers: getHeader() })
					this.getUserNotifications()
				} catch (e) {
					console.log('Notification Store (getNotifications) failed:' + e.response.data.message)
				}
			}
		},
		async markAllAsRead() {
			if (this.notifications.length > 0) {
				try {
					const notification = this.notifications[0]
					const res = await axios.put(services.notification + 'notifications/' + notification.noti_id + '?mark_all=true', null, { headers: getHeader() })
					this.getUserNotifications()
				} catch (e) {
					console.log('Notification Store (getNotifications) failed:' + e.response.data.message)
				}
			}
		},
		async createNotification(data) {
			try {
				const res = await axios.post(services.notification + 'notifications', data, { headers: getHeader() })
			} catch (e) {
				console.log('Notification Store (createNotification) failed:' + e.response.data.message)
				throw e
			}
		},
		async fetchEmailTemplate(triggerPoint) {
			try {
				const emailResponse = await axios.get(
					services.notification + "notif-template/details",
					{
						params: {
							trigger_point: triggerPoint,
							notif_temp_type: 'email',
						},
						headers: getHeader()
					}
				);
				return emailResponse.data;
				console.log(emailResponse.data);
			} catch (error) {
				console.error('Failed to fetch email template:', error);
				return null;
			}
		},
		async fetchNotificationTemplate(triggerPoint) {
			try {
				const emailResponse = await axios.get(
					services.notification + "notif-template/details",
					{
						params: {
							trigger_point: triggerPoint,
							notif_temp_type: 'bell',
						},
						headers: getHeader()
					}
				);
				return emailResponse.data;
				console.log(emailResponse.data);
			} catch (error) {
				console.error('Failed to fetch notification template:', error);
				return null;
			}
		},
		createBellNotif(trigger, data){
			let notif_params = _gNotif.generateBellNotif(trigger, data, '');
			let userIds = _gHlp.getValue(data, 'user_ids', []);
			if(_gHlp.isEmpty(userIds)){
				const userList = useAccessControlStore().userList
				if(!_gHlp.isEmpty(userList)){
					for (const key in userList) {
						const user = userList[key];
						if(user.id != _gAuth.activeUserId()){	
							userIds.push(user.id)
						}
					}
				}
			}

			if(!_gHlp.isEmpty(notif_params) && !_gHlp.isEmpty(userIds)){
				for (const key in userIds) {
					const user_id = userIds[key];
					if(user_id && (typeof user_id == 'number') && (user_id != _gAuth.activeUserId())){
						let notifData = { ...notif_params, noti_user_id: user_id }
						this.createNotification(notifData)
					}
				}
			}

		},
		getTemplates(params={}) {
			return new Promise((resolve, reject) => {
				let queryParams = _gHlp.generateQueryParams(params)
				axios.get(services.notification + 'notif-templates?' + queryParams, { headers: getHeader() })
					.then(res => {
						console.log(res)
						resolve(_gHlp.getValue(res,'data',[]));
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		createTemplate(params) {
			return new Promise((resolve, reject) => {
				axios.post(services.notification + 'notif-template',params, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		updateTemplate(id,params={}) {
			return new Promise((resolve, reject) => {
				axios.put(services.notification + 'notif-template/'+id, params, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		deleteTemplate(id) {
			return new Promise((resolve, reject) => {
				axios.delete(services.notification + 'notif-template/'+id, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
	}
})